export default "/fonts/vendor/mdui/dist/roboto/Roboto-Black.woff2?bcccd7dfcdeddf586f5e0bd77dda204d";